import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { getloadCVUploadsByWorkspaceInLast30DaysCount } from 'wisestep-api';
import { WsTypography, WsColors } from 'wisestep-base';

import NoDataFoundCard from '../../../../components/noDataFoundCard';
import { getSumOfColumnRecords } from '../../../../features/composableAnalytics/BaseCharts/clientListing/helper/payloadsAndTypesHelper';

type ArrayInterface = {
  headerName?: string;
  field: string;
  width: number;
};

const CVUpload30DaysTable = ({ payload }) => {
  const paginationSize = 10;
  const [tableDataFinal, setTableDataFinal] = useState<object[]>();
  const [columnDefinition, setColumnDefinition] = useState<ArrayInterface[]>([]);

  useEffect(() => {
    const allNewCols: ArrayInterface[] = [];
    const tableDataLocal: object[] = [];
    async function fetchData() {
      const response = await getloadCVUploadsByWorkspaceInLast30DaysCount(payload);
      response.data.forEach((row: any, index: number) => {
        const cvUploadData: any = {};
        if (index === 0) {
          allNewCols.push(
            { headerName: 'Workspace', field: 'workspace', width: 150 },
            { headerName: 'Total Count', field: 'totalCount', width: 160 }
          );
        }
        cvUploadData['workspace'] = row.workspaceName == null ? 'Not Available' : row.workspaceName;
        cvUploadData['id'] = uuid();
        let totalAllDates = 0;
        for (let i = 0; i < 30; i++) {
          const fieldName = `createdOn${i}`;
          const fieldValue = row[fieldName] || 0;
          if (index === 0) {
            const date = new Date();
            date.setDate(date.getDate() - i);
            const headerName = date.toISOString().slice(0, 10);
            allNewCols.push({
              headerName: headerName,
              field: fieldName,
              width: 180,
            });
          }
          cvUploadData[fieldName] = fieldValue;
          totalAllDates += fieldValue;
        }
        cvUploadData['totalCount'] = totalAllDates;
        tableDataLocal.push(cvUploadData);
        if (index === 0) setColumnDefinition(allNewCols);
      });
      setTableDataFinal(tableDataLocal);
    }
    fetchData();
  }, [payload]);

  return (
    <Box>
      <WsTypography>CVs uploaded by Workspace in Last 30days</WsTypography>
      {tableDataFinal ? (
        <Box style={{ height: 620, background: WsColors.White }}>
          <DataGrid
            sx={{
              '& .MuiDataGrid-columnHeaderTitle.css-1jbbcbn-MuiDataGrid-columnHeaderTitle': {
                fontWeight: '800',
              },
            }}
            columns={getSumOfColumnRecords(tableDataFinal, columnDefinition, ['id', 'workspace'])}
            rows={tableDataFinal}
            components={{ Toolbar: GridToolbar }}
            pageSize={paginationSize}
            rowsPerPageOptions={[paginationSize]}
          />
        </Box>
      ) : (
        <NoDataFoundCard text="No Records Found" />
      )}
    </Box>
  );
};
export default CVUpload30DaysTable;
